// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1tlB_","title":"Info_title__3ZM13","selects":"Info_selects__1o22A","requiredAsterisk":"Info_requiredAsterisk__YY3KS"};